<template>
    <div class="footer-toolbox">
        <div class="buttons-wrapper" @mouseleave="zoomEnabled = false">
            <div
                class="buttons-wrapper-button"
                v-tippy="{ followCursor: true, placement: 'top-center' }"
                content="Start Point"
                @click="focusStartPoint"
            >
                <span class="material-icons"> home </span>
            </div>
            <div
                class="buttons-wrapper-button"
                v-tippy="{ followCursor: true, placement: 'top-center' }"
                content="Fullscreen"
            >
                <span class="material-icons"> open_with </span>
            </div>
            <div class="buttons-wrapper-separator"></div>
            <div
                class="buttons-wrapper-button"
                v-if="zoomEnabled"
                v-tippy="{ followCursor: true, placement: 'top-center' }"
                content="Zoom in"
                @click="$emit('updateScale', scale + 0.1)"
            >
                <span class="material-icons"> add </span>
            </div>
            <div
                class="buttons-wrapper-button"
                v-if="zoomEnabled"
                v-tippy="{ followCursor: true, placement: 'top-center' }"
                content="Zoom out"
                @click="$emit('updateScale', scale - 0.1)"
            >
                <span class="material-icons"> remove </span>
            </div>
            <div
                class="buttons-wrapper-button zoom"
                @mouseover="zoomEnabled = true"
                v-tippy="{ followCursor: true, placement: 'top-center' }"
                content="Reset Zoom"
                @click="$emit('updateScale', 1)"
            >
                {{ getPercentScale }}%
            </div>
            <div class="buttons-wrapper-separator"></div>
            <div
                class="buttons-wrapper-button"
                v-tippy="{ followCursor: true, placement: 'top-center' }"
                content="Harita"
                @click="toggleMinimap"
            >
                <span class="material-icons"> map </span>
            </div>
        </div>
        <div class="buttons-wrapper ml-2">
            <div
                class="buttons-wrapper-button"
                v-tippy="{ followCursor: true, placement: 'top-center' }"
                content="Undo"
                :data-disabled="!canUndo || previewMode"
                @click="undo"
            >
                <span class="material-icons"> undo </span>
            </div>
            <div class="buttons-wrapper-separator"></div>
            <div
                class="buttons-wrapper-button"
                v-tippy="{ followCursor: true, placement: 'top-center' }"
                content="Redo"
                :data-disabled="!canRedo || previewMode"
                @click="redo"
            >
                <span class="material-icons"> redo </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FooterToolbar",
    props: ["scale", "focusStartPoint", "board", "storyId", "storyVersion", "previewMode"],
    computed: {
        getPercentScale() {
            return Math.round(this.scale * (1 / 100) * 10000);
        },
        canUndo() {
            const { currentPosition, items } = this.board.undo || { currentPosition: 0, items: [] };
            console.log("canUndo", { currentPosition, length: items.length });
            return items.length ? currentPosition < items.length - 1 : false;
        },
        canRedo() {
            const { currentPosition, items } = this.board.undo || { currentPosition: 0, items: [] };
            console.log("canRedo", { currentPosition, length: items.length });
            return items.length ? currentPosition > 0 : false;
        },
    },
    methods: {
        ...mapActions({
            undoDiagram: "CB/undoDiagram",
            redoDiagram: "CB/redoDiagram",
        }),
        undo() {
            if (this.canUndo) this.undoDiagram({ id: this.storyId, version: this.storyVersion });
        },
        redo() {
            if (this.canRedo) this.redoDiagram({ id: this.storyId, version: this.storyVersion });
        },
        toggleMinimap() {
            this.$emit('toggleMinimap');
        },
    },
    data() {
        return {
            zoomEnabled: false,
        };
    },
};
</script>

<style lang="scss">
.footer-toolbox {
    bottom: 15px;
    display: flex;
    height: 40px;
    left: 15px;
    position: absolute;
    user-select: none;
    z-index: 99;
    flex-direction: row;

    .buttons-wrapper {
        background: var(--color-bg-neutral-default);
        border-radius: 4px;
        display: flex;
        padding: 0 5px;
        pointer-events: all;
        color: var(--default-text-color);
        .material-icons {
            font-size: 22px;
            font-style: normal;
            font-variant: normal;
            font-weight: 400;
            letter-spacing: 0;
            line-height: 1;
            text-transform: none;
            font-feature-settings: "liga";
            -webkit-font-smoothing: antialiased;
            color: var(--default-text-color);
        }

        .buttons-wrapper-separator {
            background: #dbe1e8;
            height: 100%;
            margin: 0 5px;
            width: 1px;
        }

        .buttons-wrapper-button {
            align-items: center;
            display: flex;
            height: 100%;
            justify-content: center;
            width: 32px;

            &.zoom {
                font-weight: 600;
                width: 50px;
            }

            &:not([data-disabled="true"]) {
                color: #22272d;
                cursor: pointer;
                -webkit-transition: all 0.3s;
                transition: all 0.3s;

                &:hover {
                    opacity: 0.8 !important;

                    .material-icons {
                        color: #008aff;
                    }
                }
            }

            &[data-disabled="true"] {
                cursor: not-allowed;

                .material-icons {
                    color: #9ba6b3;
                }
            }
        }
    }
}
</style>
